import reframe from 'nike-re-framejs';
import { getUrl } from '@/common/oldMobile';
import Immutable from 'immutable';
import axios from 'axios';
import { catcher } from '@/_http/utils';
import { cmsSectionLoaded } from '@/article/handlers';

export const loadHelpArticles = function() {
    axios
        .get(getUrl('MARKDOWN_HELP'))
        .then(json => reframe.dispatch(cmsSectionLoaded('help', Immutable.fromJS(json.categories))))
        .catch(catcher.handleMasterError);
};
